import { Link } from "react-router-dom";
import { HEALTH, healthOf, isOverdue, kpiDue, openTasks, pad2 } from "../lib/domain.js";
import { Meter } from "./Meter.jsx";
import { TaskStrip } from "./TaskStrip.jsx";

/* A tile is a link, not a button: every playground has its own URL, so a
   detail view can be sent to someone in a message. */
export function PlaygroundTile({ pg }) {
  const h = healthOf(pg);
  const tone = HEALTH[h].tone;
  const open = openTasks(pg);
  const overdue = pg.tasks.filter(isOverdue).length;
  const crit = pg.tasks.filter((t) => t.critical && t.status !== "done").length;
  const kdue = pg.kpis.filter(kpiDue).length;

  return (
    <Link className={"tile " + tone} to={"/playground/" + pg.id}>
      <div className="head">
        <span className="idx">{pad2(pg.idx)}</span>
        <span
          className={"chip" + (pg.manualHealth ? " manual" : "")}
          title={pg.manualHealth ? "Health set by hand" : undefined}
        >
          <i className="dot" />
          {HEALTH[h].label}
        </span>
      </div>
      <div className="name">{pg.name}</div>
      <div className={"owner" + (pg.owner ? "" : " none")}>
        {pg.owner || "No owner yet"}
      </div>
      <Meter pg={pg} tone={tone} />
      <TaskStrip tasks={pg.tasks} />
      <div className="counts">
        <span>
          <b>{pg.players.length}</b> players
        </span>
        <span>·</span>
        <span>
          <b>{open}</b> open
        </span>
        <span>·</span>
        <span>
          <b>{pg.kpis.length}</b> KPIs
        </span>
      </div>
      {(overdue || crit || kdue) > 0 && (
        <div className="flags">
          {overdue > 0 && <span className="fl bad">{overdue} past due</span>}
          {crit > 0 && <span className="fl warn">{crit} critical</span>}
          {kdue > 0 && <span className="fl warn">{kdue} KPI review</span>}
        </div>
      )}
    </Link>
  );
}
